import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import BridleContextProvider from './BridleContextProvider';

const root = ReactDOM.createRoot(document.getElementById('bridle-builder-root'));

root.render(
    <BridleContextProvider>
        <App />
    </BridleContextProvider>
);
